/**
 * 订单接口
 * 
 * @author 张子超
 * @since 2018-04-04
 */
import common from './common'
import store from './store'

var ApiList = {};

//API 接口

/**
 * 获取京东地址列表
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getJingdongAddressList = function (okCb, failCb) {
    var p = {}
    common.Api('/customer/api/userJingdongAddress/list.json', p, okCb, failCb)
}

/**
 * 验证订单，验证结算页里的信息
 * @param {*} addressId 地址 id，订单是京东实物时传京东地址
 * @param {*} skuType  订单类型
    0: UNKNOWN
    1: VIRTUAL
    2: JINGDONG_PHYSICAL
    3: MANUAL_PHYSICAL
 * @param {*} skus 商品列表，格式为 skuId:num,skuId:num
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.validateOrder = function (addressId, skuType, skus, okCb, failCb) {
    var p = {
        addressId,
        skuType,
        skus
    }
    
    if (store.loginedUser.easyUser) {
        common.Api('/customer/api/easyOrder/validate.json', p, okCb, failCb)
    } else {
        common.Api('/customer/api/order/validate.json', p, okCb, failCb)
    }
}

/**
 * 京东黄金验证
 * @param {*} addressId 地址 id，订单是京东实物时传京东地址
 * @param {*} count 
 * @param {*} skuId 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.validateJingdongGold = function (addressId, count, skuId, okCb, failCb) {
    var p = {
        addressId,
        count, 
        skuId
    }
    if (store.loginedUser.easyUser) {
        common.Api('/customer/api/easyOrder/validateJingdongGold.json', p, okCb, failCb)
    } else {
        common.Api('/customer/api/order/validateJingdongGold.json', p, okCb, failCb)
    }
}

/**
 * 订单物流信息
 * @param {*} orderId 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getOrderDelivery = function (orderId, okCb, failCb) {
    var p = {
        orderId
    }
    common.Api('/customer/api/order/delivery.json', p, okCb, failCb)
}

/**
 * 下单
 * @param {*} addressId 地址 id，订单是京东实物时传京东地址
 * @param {*} skuType  订单类型
    0: UNKNOWN
    1: VIRTUAL
    2: JINGDONG_PHYSICAL
    3: MANUAL_PHYSICAL
 * @param {*} skus 商品列表，格式为 skuId:num,skuId:num
 * @param {*} payPoint 支付费用，传结算页里的需支付费用
 * @param {*} feeList 费用列表，将结算页的feeList按 type:point,type:point的格式传
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.takeOrder = function (addressId, skuType, skus, payPoint, feeList, machineSn, okCb, failCb) {
    var p = {
        addressId,
        skuType,
        skus,
        payPoint,
        feeList,
        machineSn
    }
    common.Api('/customer/api/order/take.json', p, okCb, failCb)
}

/**
 * 下单京东黄金
 * @param {*} addressId 地址 id，订单是京东实物时传京东地址
 * @param {*} count 
 * @param {*} skuId 
 * @param {*} payPoint 支付费用，传结算页里的需支付费用
 * @param {*} feeList 费用列表，将结算页的feeList按 type:point,type:point的格式传
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.takeJingdongGold = function (addressId, count, skuId, payPoint, feeList, machineSn, okCb, failCb) {
    var p = {
        addressId,
        count,
        skuId,
        payPoint,
        feeList,
        machineSn
    }
    common.Api('/customer/api/order/takeJingdongGold.json', p, okCb, failCb)
}

/**
 * 订单列表
 * @param {*} completed 完成状态, 0:未完成 1:已完成
 * @param {*} lastId
 * @param {*} limit 每页数据
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getOrderList = function (completed, lastId, limit, okCb, failCb) {
    var p = {
        completed,
        lastId,
        limit
    }
    common.Api('/customer/api/order/list.json', p, okCb, failCb)
}

/**
 * 获取订单详情
 * @param {*} orderno 订单编号
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getOrderDetail = function (orderno, okCb, failCb) {
    var p = {
        orderno
    }
    common.Api('/customer/api/order/detail.json', p, okCb, failCb)
}

/**
 * 删除地址
 * @param {*} addressId 
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.deleteAddress = function (addressId, okCb, failCb) {
    var p = {
        id:addressId
    }
    //TODO
    console.log('删除地址');
    common.Api('/customer/api/userJingdongAddress/delete.json', p, okCb, failCb)
}

ApiList.setDefault = function (integer, okCb, failCb) {
    var p = {
        id:integer
    }
    common.Api('/customer/api/userJingdongAddress/setDefault.json', p, okCb, failCb)
}

ApiList.getAddressDetail = function (integer, okCb, failCb) {
    var p = {
        id:integer
    }
    common.Api('/customer/api/userJingdongAddress/detail.json', p, okCb, failCb)
}

ApiList.editAddress = function (id,isDefault,provinceCode, cityCode, districtCode, townCode, detail, receiver, telephone, okCb, failCb) {
    var p = {
		id,
		isDefault,
		provinceCode, 
		cityCode, 
		districtCode, 
		townCode, 
		detail, 
		receiver, 
		telephone,
    }
    common.Api('/customer/api/userJingdongAddress/edit.json', p, okCb, failCb)
}

ApiList.getDefault = function (integer,okCb, failCb) {
	var p = {
        id:integer
    }
    common.Api('/customer/api/userJingdongAddress/default.json',p, okCb, failCb)
}

export default ApiList;


// WEBPACK FOOTER //
// ./src/api/order-api.js